import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  MdClose,
  MdFileDownload,
  MdOutlineEmojiEmotions,
  MdPhoneForwarded
} from 'react-icons/md';

import { useSelector, useDispatch } from 'react-redux';
import Picker from 'emoji-picker-react';
import PredefinedMessageService from '../../../PredefinedMessage/service';
import Select from 'react-select';
import { custom_select_40vw } from '../../../../assets/styles/multiple_select';

import { Button } from 'reactstrap';
import ClientBalloon from '../../../../components/Conversation/ChatBallons/Client';
import UserBalloon from '../../../../components/Conversation/ChatBallons/User';
import SpyBallon from '../../../../components/Conversation/ChatBallons/Spy';
import { toast } from 'react-toastify';
import { apiChat, apiInstagramChat, apiSMSChat } from '../../../../http';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ConversationReportService from '../../../ChatConfiguration/service/index';
import ConversationService from '../../service';
import { RiAttachment2 } from 'react-icons/ri';

import {
  Hr,
  Header,
  Dialog,
  HeaderOptions,
  EmptyAttendance,
  Bottom,
  LeftArea,
  RightArea,
  Option
} from './components/styled';
import CloseConversation from './components/Modal/CloseConversation';
import TransferConversation from './components/Modal/TransferConversation';
import HistoryConversation from './components/Modal/HistoryConversation';
import TimelineConversation from './components/Modal/TimelineConversation';
import ResumeConversation from './components/Modal/ResumeConversation';
import UploadFile from './components/Modal/UploadFile';
import AudioSender from './components/AudioSender';
import { useConectionSocketAdmConversation } from 'hooks/useSocketAdmConversations';
import { addMessageConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { addMessageAnsweredConversation } from 'store/action/answered-conversations-action';
import ClickToCall from './components/Modal/ClickToCall';
import ContactDetails from './components/Modal/ContactDetails';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import { useFileUploadModalHandler } from './components/Modal/UploadFile/hooks/useFileUploadModalHandler';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import ReactLoader from 'components/Loader';
import {
  InputContainer,
  ReplyContainerOnTopOfInput,
  SelectableOption
} from './styles';
import AddActiveContact from './components/Modal/AddActiveContact';
import { dataURLtoFile } from './utils/transformImageData';
import TemplatesModal from './components/TemplatesModal';
import { ModalLeadOpportunity } from './components/Modal/ModalLeadOpportunity';
import axios from 'axios';
import FlexChatIntegration from '../QueueContent/components/Contact/service/FlexChatIntegration';
import ContactService from '../QueueContent/components/Contact/service/index';
import ReplyMessage from '../../.././../components/Conversation/ChatBallons/components/ReplyMessage';
import { useMemo } from 'react';

import WhisperModal from '../../../../../src/views/Monitoring/Chat/conversation/components/table/components/notificationModal/whisperModal/index.js';
import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import { MessageSendingBlockerCustomerInactive } from './components/MessageSendingBlocker';
import { PauseBlockerCustomerInactive } from './components/PauseChatBlock';
import { getIdClientFromChat } from 'utils/fuctions/getIdClientFromChat';

import { PredefinedMessageModal } from 'views/Protocol/updateForm/components/modal/PredefinedMessageModal';
import { IoSend } from 'react-icons/io5';
import NewMessagesIndicator from './components/NewMessageIndicator';

/**
 * Representa uma mensagem pré-definida a ser utilizada no módulo de Atendimento
 *
 * @typedef TemplateMessage
 * @property {String[]} channel - A lista de canais aos quais a mensagem pré-definida está vinculada.
 * @property {String | null} messageHtml - A mensagem que será encaminhada pelo email, em forma de html
 * @property {String} message - A mensagem que será enviada pelo whatsapp, em forma de html
 * @property {Number[]} teams - As equipes que estão vinculados à mensagem pré-definida
 * @property {String} title - O título da mensagem pré-definida
 * @property {String} preDefinedMessageMidiaUrl - A URL da mídia vinculada à mensagem pré-definida
 * @property {"1" | "2" | "3" | "" |  null} whenToSend - Determina se a mídia deve ser enviada antes, em conjunto, ou depois do texto da mensagem. 1 - Antes da mensagem. 2 - Junto da mensagem. 3 - Depois da mensagem.
 * @property {String} id - O identificador único da mensagem pré-definida
 */

/**
 * Representa a forma pela qual este componente trabalha com as `TemplateMessages`
 * @typedef {Object} ConvertedTemplateMessage
 * @property {String} label - A forma pela qual `TemplateMessages.title` é chamada
 * @property {String} value - A forma pela qual `TemplateMessages.value` é chamada
 * @property {String} equipes - A forma pela qual `TemplateMessages.teams` é chamada
 * @property {String} preDefinedMessageMidiaUrl - A forma pela qual `TemplateMessages.preDefinedMessageMidiaUrl` é chamada
 * @property {String} whenToSend - A forma pela qual `TemplateMessages.whenToSend` é chamada
 * @see {TemplateMessage}
 */

const { saveAs } = require('file-saver');

const AttendanceContent = () => {
  const { messageSendingBlocked, queuesChatLoggedValues } =
    useQueueChatPauseContext();
  const newContactInfo = useSelector((state) => state.contactEvents);
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const [shouldCreateProtocol, setShouldCreateProtocol] = useState();
  const { socketAdm } = useConectionSocketAdmConversation();
  const { isOpen, changeStatus } = useFileUploadModalHandler();
  const [clientActiveSession, setClientActiveSession] = useState(true);
  const [message, setMessage] = useState('');
  const [showEmojis, setShowEmojis] = useState(false);
  const [conversation, setConversation] = useState(null);
  const [unreadMessagesByConversation, setUnreadMessagesByConversation] =
    useState({});
  const [isAtBottom, setIsAtBottom] = useState(false);
  /**
   * Armazena as mensagens pré-definidas disponíveis em um canal específico para um usuário específico
   * @type {[ConvertedTemplateMessage[], React.Dispatch<React.SetStateAction<ConvertedTemplateMessage[]>>]}
   */
  const [predefinedMessageOptions, setPredefinedMessageOptions] = useState([]);

  /**
   * Armazena as mensagens pré-definidas disponíveis em um canal específico para um usuário específico no formato que o `PredefinedMessageModal` aceita
   * @type {[TemplateMessages[], React.Dispatch<React.SetStateAction<TemplateMessages[]>>]}
   */
  const [
    unconvertedPredefinedMessageOptions,
    setUnconvertedPredefinedMessageOptions
  ] = useState([]);

  const [isPredefinedMessageModalOpen, setIsPredefinedMessageModalOpen] =
    useState(false);

  const [
    selectedPredefinedMessageOrderToSend,
    setSelectedPredefinedMessageOrderToSend
  ] = useState(null);
  const [clientTyping, setClientTyping] = useState(false);
  const [attendantTyping, setAttendantTyping] = useState(false);
  const [disableClickToCall, setDisableClickToCall] = useState(true);
  const [recording, setRecording] = useState(false);
  const [loggedAttendants, setLoggedAttendants] = useState([]);
  const [filesLoadedOnPaste, setFilesLoadedOnPaste] = useState(null);

  const messagesEndRef = useRef(null);
  const previousConversationIdRef = useRef(null);
  const [isSending, setIsSending] = useState(false);
  const [messages, setMessages] = useState({});
  const messageArea = useRef(null);
  const lastMessageCountRef = useRef({});
  const dispatch = useDispatch();
  const [modalConversationVisbility, setModalConversationVisbility] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [newContactInfoController, setNewContactInfoController] =
    useState(null);
  const [contactId, setContactId] = useState(null);
  const [inReplyToMessageId, setInReplyToMessageId] = useState(null);
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const [selectMessagePredefined, setSelectMessagePredefined] = useState(false);

  const conversationInAttendance = useSelector(
    (state) => state.conversationInAttendance
  );

  const telephonyServicePanel = useSelector(
    (state) => state.telephonyServicePanel
  );
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const wrapperRef = useRef(null);

  useEffect(() => {
    const usrLogin = localStorage.getItem('login');
    if (
      conversation &&
      usrLogin &&
      getIdClientFromChat(conversation) &&
      modalConversationVisbility
    ) {
      ContactService.getContactByClientId(
        getIdClientFromChat(conversation),
        usrLogin
      )
        .then((response) => {
          setContactId(response.data.id);
        })
        .catch((error) => {
          console.error('Erro ao tentar pegar o contactId =>', error);
        });
    }
  }, [conversation, modalConversationVisbility]);

  const isWhatsappOrFacebookChannel =
    (conversation && conversation.canal === 'whatsapp') ||
    (conversation && conversation.canal === 'facebook');

  const scrollToMessage = (messageId) => {
    const element = document.getElementById(messageId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setHighlightedMessageId(messageId);
      setTimeout(() => {
        setHighlightedMessageId(null);
      }, 1000);
    }
  };

  //socket listeners
  useEffect(() => {
    socketConversation.on('digitando_cliente', (data) => {
      setClientTyping(data.digitando);
    });

    socketConversation.on('parou_digitar_cliente', (data) => {
      setClientTyping(data.digitando);
    });

    socketConversation.on('mensagem_antendente_chegou', async (messageData) => {
      await dispatch(
        addMessageConversationInAttendance(
          { ...messageData.message },
          messageData.conversaId
        )
      );
      //updating list of answeredConversations in store
      await dispatch(
        addMessageAnsweredConversation(
          { ...messageData.message },
          messageData.conversaId
        )
      );
    });
  }, [socketConversation, dispatch]);

  useEffect(() => {
    ConversationReportService.getConfigProtocolChat()
      .then((response) => {
        const result = response.data;
        setShouldCreateProtocol(result.criarProtocoloParaConversaNoAtendimento);
      })
      .catch((error) => {
        if (error.response) {
          toast.error('Erro ao carregar configurações!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });
  }, []);

  useEffect(() => {
    if (Object.keys(newContactInfo.contactInfo).length > 0) {
      setNewContactInfoController(newContactInfo.contactInfo);
    }
  }, [newContactInfo]);

  const checkHaveClientMessage = useCallback(() => {
    const clientMessage = conversation.mensagens.filter((message) => {
      return message.cliente_ou_atendente === 'cliente';
    });

    if (!clientMessage || clientActiveSession.length === 0) return false;

    const [lastClientMessage] = clientMessage.slice(-1);

    if (!lastClientMessage) return false;

    const today = new Date();
    const yesterday = new Date();
    const lastMessageTimeStamp = new Date(lastClientMessage.hora_da_mensagem);

    yesterday.setDate(today.getDate() - 1);

    const userActive = !(lastMessageTimeStamp < yesterday);

    return userActive;
  }, [conversation]);

  const verifyClientStatus = useCallback(async () => {
    if (isWhatsappOrFacebookChannel) {
      const hasClientMessage = checkHaveClientMessage(conversation);
      setClientActiveSession(hasClientMessage);
    }
  }, [checkHaveClientMessage, conversation, isWhatsappOrFacebookChannel]);

  useEffect(() => {
    if (
      conversationInAttendance &&
      conversationInAttendance.conversation &&
      Object.keys(conversationInAttendance.conversation).length !== 0
    ) {
      setConversation({
        ...conversationInAttendance.conversation
      });
    } else {
      setConversation(null);
      setInReplyToMessageId(null);
    }
  }, [conversationInAttendance]);

  //Check active conversation and set sessions
  useEffect(() => {
    if (conversation) {
      verifyClientStatus();
    }
  }, [verifyClientStatus, conversation]);
  useEffect(() => {
    if (!isOpen) {
      setFilesLoadedOnPaste(null);
    }
  }, [isOpen]);

  useEffect(() => {
    if (telephonyServicePanel.extension === '') {
      setDisableClickToCall(true);
    } else {
      setDisableClickToCall(false);
    }
  }, [telephonyServicePanel]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowEmojis(false);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  //*
  useEffect(() => {
    socketConversation.emit('lista_atendentes_logados');
    let userTeam = localStorage.getItem('teams');
    if (userTeam) {
      userTeam = JSON.parse(userTeam);
    }
    socketAdm.on('atendentes_logados', (data) => {
      setLoggedAttendants(data?.atendentes);
    });
  }, [socketAdm, socketConversation]);

  const handleMessageChange = (event) => {
    const text = event.target.value || '';

    if (
      text.length !== 0 &&
      attendantTyping === false &&
      conversation?.canal === 'chat'
    ) {
      setAttendantTyping(true);
      socketConversation.emit('digitando', conversation._id);
    } else if (text.length === 0 && conversation?.canal === 'chat') {
      setAttendantTyping(false);
      socketConversation.emit('parou_digitar', conversation._id);
    }

    setMessages((prevMessages) => ({
      ...prevMessages,
      [getIdClientFromChat(conversation)]: text
    }));
    setMessage(text);
  };

  const handlePressEnter = (event) => {
    const currentMessage = messages[getIdClientFromChat(conversation)] || '';
    if (currentMessage !== '' && event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSubmitMiddleware();

      setMessages((prevMessages) => ({
        ...prevMessages,
        [getIdClientFromChat(conversation)]: ''
      }));
    }

    if (currentMessage === '' && event.key === 'Enter') event.preventDefault();
  };

  const onEmojiClick = (event, emojiObject) => {
    const text = messages[getIdClientFromChat(conversation)] || '';
    setMessages((prevMessages) => ({
      ...prevMessages,
      [getIdClientFromChat(conversation)]: text.concat(emojiObject.emoji)
    }));
    // setMessage();
    setShowEmojis(false);
  };

  /** @param {ConvertedTemplateMessage} event */
  const selectPredefinedMessage = (event) => {
    setSelectMessagePredefined(true);
    const text = messages[getIdClientFromChat(conversation)] || '';
    setSelectedPredefinedMessageOrderToSend(event);

    setMessages((prevMessages) => ({
      ...prevMessages,
      [getIdClientFromChat(conversation)]: text.concat(event.value)
    }));
    // setMessage();
    document.getElementById('text-area').focus();
  };

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'auto', block: 'end' });
    }
  };

  const onSubmit = async () => {
    setIsSending(true);
    const containsLink =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi.test(
        message
      );

    try {
      const messageData = {
        cliente_ou_atendente: 'atendente',
        escrita_por: localStorage.getItem('name'),
        texto: messages[getIdClientFromChat(conversation)],
        response_type: containsLink ? 'link' : 'text'
      };

      let response;
      let responsePayload;

      if (conversation.canal === 'instagram') {
        response = await apiInstagramChat.post(
          `/instagram/send-message/${conversation.id}`,
          {
            idDaConversa: conversation.id,
            conversa: {
              mensagem: {
                cliente_ou_atendente: 'atendente',
                escrita_por: localStorage.getItem('name'),
                texto: messageData.texto,
                response_type: 'text'
              }
            }
          }
        );
        responsePayload = response.data.data;
      } else if (conversation.canal === 'whatsapp') {
        response = await apiInstagramChat.post(
          `/whatsapp/send-message/text/${conversation.id}`,
          {
            idDaConversa: conversation._id,
            conversa: {
              mensagem: {
                ...messageData,
                inReplyTo: inReplyToMessageId ?? undefined
              }
            }
          }
        );

        responsePayload = response.data.data;
      } else if (conversation.canal === 'sms') {
        response = await apiSMSChat.post(
          `/sms/send-message/${conversation._id}`,
          {
            idDaConversa: conversation._id,
            conversa: {
              mensagem: {
                cliente_ou_atendente: conversation.cliente.id_zenvia_sms,
                escrita_por: localStorage.getItem('name'),
                texto: messageData.texto,
                response_type: 'text'
              }
            }
          }
        );
        responsePayload = response.data.data;
      } else if (conversation.canal === 'chat') {
        response = await apiSMSChat.post(`/webchat/send-message/text`, {
          chatId: conversation._id || conversation.id,

          message: { ...messageData }
        });

        responsePayload = response.data.data;
      } else if (conversation.canal === 'flex4u') {
        response = await apiSMSChat.post(`/flex4u/send-message/text`, {
          chatId: conversation._id,
          message: { ...messageData }
        });
        responsePayload = response.data.data;
      } else {
        response = await apiChat.post(`/conversa/atendente-enviar-mensagem`, {
          chatId: conversation._id ?? conversation.id,
          message: {
            mensagem: { ...messageData }
          }
        });
        responsePayload = response.data.message;
      }

      const conversationId = conversation._id ?? conversation.id;

      await dispatch(
        addMessageConversationInAttendance(
          { ...responsePayload },
          conversationId
        )
      );
      //updating list of answeredConversations in store
      await dispatch(
        addMessageAnsweredConversation({ ...responsePayload }, conversationId)
      );

      await socketConversation.emit('parou_digitar', conversationId);
      setAttendantTyping(false);
      setMessage(messages[getIdClientFromChat(conversation)]);
      delete messages[getIdClientFromChat(conversation)];
      setIsSending(false);
      scrollToBottom();
      setInReplyToMessageId(null);
    } catch (err) {
      toast.warning(err?.response?.data?.message || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setIsSending(false);
      document.getElementById('text-area').focus();
      scrollToBottom();
    }
  };

  async function fetchMidiaAndAppendToFormData(midiaUrl) {
    const newFile = fetch(midiaUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], 'file', { type: blob.type });
        return file;
      });

    const file = await newFile;
    return file;
  }

  const sendMidiaWithUrl = async (midiaUrl) => {
    if (midiaUrl === '') {
      return;
    }
    try {
      const conversationId = conversation._id ?? conversation.id;
      const formatedData = new FormData();

      const updatedFormDataMidia = await fetchMidiaAndAppendToFormData(
        midiaUrl
      );

      const fileType = updatedFormDataMidia.type.split('/')[0];

      formatedData.append('file', updatedFormDataMidia);

      const dateNow = new Date();
      formatedData.append('idDaConversa', conversationId);
      formatedData.append('cliente_ou_atendente', 'atendente');
      formatedData.append('escrita_por', localStorage.getItem('name'));
      if (selectedPredefinedMessageOrderToSend.whenToSend === '3') {
        formatedData.append('message', message);
      }

      const gupshupFileType = fileType == 'image' ? 'image' : 'file';

      formatedData.append('response_type', gupshupFileType);
      formatedData.append('type', gupshupFileType);
      formatedData.append(
        'legenda',
        `upload_atendente_${dateNow.toLocaleDateString(
          'pt-br'
        )}-${dateNow.toLocaleTimeString('pt-br')}`
      );

      if (
        conversation.canal === 'whatsapp' ||
        conversation.canal === 'chat' ||
        conversation.canal === 'flex4u'
      ) {
        if (conversation.canal === 'whatsapp') {
          if (inReplyToMessageId) {
            formatedData.append('inReplyTo', inReplyToMessageId);
            setInReplyToMessageId(null);
          }

          return FlexChatIntegration.uploadFile(
            conversation._id ?? conversation.id,
            formatedData
          )
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              scrollToBottom();
              setIsSending(false);
            });
        } else if (conversation.canal === 'flex4u') {
          FlexChatIntegration.uploadFileFlex4U(formatedData)
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              scrollToBottom();
              setIsSending(false);
            });
        } else {
          FlexChatIntegration.uploadFileWebchat(formatedData)
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              scrollToBottom();
              setIsSending(false);
            });
        }

        return;
      }

      ConversationService.uploadFile(formatedData)
        .then((res) => {
          dispatch(
            addMessageConversationInAttendance({ ...res.data }, conversationId)
          );
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          scrollToBottom();
          setIsSending(false);
        });
    } catch (err) {
      toast.error(err || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  useEffect(() => {
    if (conversation) {
      if (conversation?.idCanal) {
        PredefinedMessageService.getByChannel(conversation?.idCanal)
          .then((response) => {
            /**
             * @type {TemplateMessage[]}
             */
            const untreatedTemplateMessages = response.data;

            /**
             * @type {string} - Uma string em formato de array que mostra todos os times dos quais o usuário faz parte
             * @example '[1,51,19,20,21,23,22,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,48,53,11,54,10,9,39,40,41,42,43,52,8,44,45,47,49,46,13,14]'
             */
            const untreatedUserTeams = localStorage.getItem('teams') ?? '';
            /**
             * Representa todos os times dos quais o usuário faz parte
             */
            const treatedUserTeams = untreatedUserTeams
              .replace(/[\[\]]/g, '')
              .split(',')
              .map(Number);

            const treatedTemplateMessages = untreatedTemplateMessages.filter(
              (message) => {
                // Caso a mensagem tenha em algum de seus times um time ao qual o usuário faz parte, ela deve aparecer.
                return treatedUserTeams.some((userTeam) =>
                  message.teams.includes(userTeam)
                );
              }
            );

            /**
             * @type {ConvertedTemplateMessage[]}
             */
            const convertedTemplateMessage = treatedTemplateMessages.map(
              (message) => ({
                label: message.title,
                value: message.message,
                equipes: message.teams,
                preDefinedMessageMidiaUrl: message.preDefinedMessageMidiaUrl,
                whenToSend: message.whenToSend
              })
            );

            setUnconvertedPredefinedMessageOptions(treatedTemplateMessages);
            setPredefinedMessageOptions(convertedTemplateMessage);
          })
          .catch((err) => {
            console.log('err: ' + err);
          });
      }
    }
  }, [conversation]);

  useEffect(() => {
    if (conversation) {
      const currentConversationId = conversation._id ?? conversation.id;
      if (previousConversationIdRef.current !== currentConversationId) {
        scrollToBottom();
        previousConversationIdRef.current = currentConversationId;
      }
    }
  }, [conversation]);

  const callBack = () => {
    const data = {
      origem: telephonyServicePanel.extension,
      destino: conversation.cliente.telefone,
      id_conversa: conversation._id ?? conversation.id
    };

    if (disableClickToCall) {
      toast.error(
        'É necessário estar logado em um ramal para realizar a chamada!',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    } else {
      if (!window.confirm('Tem certeza que deseja realizar a chamada agora?'))
        return;

      apiChat
        .post(`/clicktocall`, data)
        .then(() => {
          toast.success('Realizando chamada!', {
            autoClose: 3000,
            closeOnClick: true
          });
        })
        .catch((err) => {
          console.error(err.response.data.msg);
          toast.error(err.response.data.msg || 'Erro ao realizar chamada!');
        });
    }
  };

  const handleImageFormatFromPaste = (file) => {
    const files = file.items;
    for (let i = 0; i < files.length; i++) {
      if (files[i].type.indexOf('image') !== -1) {
        const fileReader = new FileReader();
        const blob = files[i].getAsFile();
        fileReader.onload = function (event) {
          const imageToPaste = dataURLtoFile(
            event.target.result,
            `${Date.now()}.png`
          );
          setFilesLoadedOnPaste([imageToPaste]);
        };
        fileReader.readAsDataURL(blob);
        break;
      }
    }
  };

  const handleOnInputPaste = (event) => {
    const clipboardData =
      event.clipboardData || event.originalEvent.clipboardData;
    handleImageFormatFromPaste(clipboardData);
    const text = clipboardData.getData('Text');
    if (text) return false;

    const files = clipboardData.files;
    if (!files) return false;

    setFilesLoadedOnPaste(files);
  };

  const onDropHandle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { files } = event.dataTransfer;
    if (!files) return false;

    setFilesLoadedOnPaste(files);
  };

  const handleOnDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  };

  const mediaTypes = ['image', 'audio', 'video', 'file'];

  const mediaList = conversation?.mensagens.filter((msg) => {
    return mediaTypes.includes(msg?.response_type);
  });

  const verifyContactInfoName = () =>
    newContactInfoController?.conversationId ===
    getIdClientFromChat(conversation)
      ? newContactInfoController?.contactName
      : conversation.cliente.nome;

  async function baixarMidia(mensagem) {
    try {
      const response = await axios.get(mensagem.source, {
        responseType: 'blob'
      });
      const fileType = response?.data?.type?.split('/');
      const extensao = fileType[1];
      const nomeArquivo = `${mensagem.mid}.${extensao}`;

      if (response.data instanceof Blob) {
        saveAs(response.data, nomeArquivo);
      }
    } catch (error) {
      toast.error('Erro ao baixar arquivos', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  }

  async function baixarTodasAsMidias() {
    setIsLoading(true);
    if (!mediaList.length) {
      toast.error('Não há arquivos nesta conversa');
      setIsLoading(false);
      return;
    }
    for (const mensagem of mediaList) {
      if (
        mensagem.response_type === 'image' ||
        mensagem.response_type === 'audio' ||
        mensagem.response_type === 'video' ||
        mensagem.response_type === 'file'
      ) {
        await baixarMidia(mensagem);
      }
    }
    setIsLoading(false);
  }
  const onSubmitMiddleware = async () => {
    setIsSending(true);
    setSelectMessagePredefined(false);
    if (selectedPredefinedMessageOrderToSend?.whenToSend === '1') {
      await sendMidiaWithUrl(
        selectedPredefinedMessageOrderToSend?.preDefinedMessageMidiaUrl
      );
      setTimeout(onSubmit, 1000);
      setSelectedPredefinedMessageOrderToSend(null);
      setIsSending(false);
      setMessage('');
      return;
    }
    if (selectedPredefinedMessageOrderToSend?.whenToSend === '2') {
      await onSubmit();
      await sendMidiaWithUrl(
        selectedPredefinedMessageOrderToSend?.preDefinedMessageMidiaUrl
      );
      setSelectedPredefinedMessageOrderToSend(null);
      setIsSending(false);
      setMessage('');
      return;
    }
    if (selectedPredefinedMessageOrderToSend?.whenToSend === '3') {
      await sendMidiaWithUrl(
        selectedPredefinedMessageOrderToSend?.preDefinedMessageMidiaUrl
      );
      setSelectedPredefinedMessageOrderToSend(null);
      setIsSending(false);
      setMessage('');
      return;
    }

    await onSubmit();
    setSelectedPredefinedMessageOrderToSend(null);
    setIsSending(false);
    setMessage('');
  };

  /** @type {(option: ConvertedTemplateMessage) => React.ReactNode } */
  const formatPredefinedMessageOption = (templateMessage) => {
    return (
      <SelectableOption>
        <div>
          <strong>Título: </strong> {templateMessage.label}
        </div>
        <div>
          <strong>Conteúdo: </strong> {templateMessage.value}
        </div>
        <div>
          <span>
            {templateMessage.whenToSend &&
              templateMessage.whenToSend != 'null' && (
                <strong>Envio da mídia: </strong>
              )}
            {templateMessage.whenToSend == '1' ? (
              <span style={{ fontWeight: 'normal' }}>antes da mensagem</span>
            ) : null}
            {templateMessage.whenToSend == '2' ? (
              <span style={{ fontWeight: 'normal' }}>junto da mensagem</span>
            ) : null}
            {templateMessage.whenToSend == '3' ? (
              <span style={{ fontWeight: 'normal' }}>depois da mensagem</span>
            ) : null}
          </span>
        </div>
      </SelectableOption>
    );
  };
  const filterPredefinedMessageOptions = predefinedMessageOptions.map(
    (option) => {
      option.value = option.value.replace(
        /#cliente/g,
        conversation?.cliente?.nome
      );
      option.value = option.value.replace(
        /#atendente/g,
        conversation?.atendente?.name
      );
      option.value = option.value.replace(
        /#CLIENTE/g,
        conversation?.cliente?.nome
      );
      option.value = option.value.replace(
        /#ATENDENTE/g,
        conversation?.atendente?.name
      );
      return option;
    }
  );

  const customFilter = (option, inputValue) => {
    if (!inputValue) {
      return true;
    }
    const mensagemFiltrada =
      option?.data?.label?.toLowerCase().includes(inputValue.toLowerCase()) ||
      option?.data?.value?.toLowerCase().includes(inputValue.toLowerCase());

    return mensagemFiltrada;
  };

  const setInReplyToMessageIdHandler = (messageId) => {
    setInReplyToMessageId(messageId);
    const textAreaElement = document.getElementById('text-area');
    if (textAreaElement) {
      textAreaElement.focus();
    } else {
      console.warn('Elemento com ID "text-area" não encontrado.');
    }
  };

  const context = useMemo(() => {
    return inReplyToMessageId
      ? conversation?.mensagens.find(
          (mensagen) => mensagen.id_mensagem_whatsapp === inReplyToMessageId
        )
      : null;
  }, [inReplyToMessageId, conversation?.mensagens]);

  const handlerShowModalConversation = () => {
    setModalConversationVisbility(!modalConversationVisbility);
  };

  const handleScroll = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const bottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 200;
    setIsAtBottom(bottom);

    if (bottom && conversation) {
      const conversationId = conversation._id ?? conversation.id;
      setUnreadMessagesByConversation((prev) => ({
        ...prev,
        [conversationId]: 0
      }));
    }
  };

  useEffect(() => {
    if (conversation?.mensagens) {
      const conversationId = conversation?._id ?? conversation?.id;
      const currentMessageCount = conversation.mensagens.length;
      const lastMessageCount =
        lastMessageCountRef.current[conversationId] || currentMessageCount;

      if (currentMessageCount > lastMessageCount) {
        if (!isAtBottom) {
          setUnreadMessagesByConversation((prev) => ({
            ...prev,
            [conversationId]:
              (prev[conversationId] || 0) +
              (currentMessageCount - lastMessageCount)
          }));
        } else {
          scrollToBottom();
        }
      }

      lastMessageCountRef.current[conversationId] = currentMessageCount;
    }
  }, [conversation?.mensagens, isAtBottom]);

  useEffect(() => {
    if (isAtBottom) {
      const conversationId = conversation?._id ?? conversation?.id;
      setUnreadMessagesByConversation((prev) => ({
        ...prev,
        [conversationId]: 0
      }));
    }
  }, [isAtBottom]);
  const handleIndicatorClick = () => {
    const conversationId = conversation?._id ?? conversation?.id;
    scrollToBottom();
    setUnreadMessagesByConversation((prev) => ({
      ...prev,
      [conversationId]: 0
    }));
    setIsAtBottom(true);
  };

  const customerId = useMemo(() => {
    return getIdClientFromChat(conversation);
  }, [conversation]);

  const phoneCustomer = useMemo(() => {
    return conversation?.cliente?.telefone || '';
  }, [conversation]);

  const shouldBlock = useMemo(() => {
    if (!queuesChatLoggedValues?.length) {
      if (!conversation?.atendida && conversation?.atendente?.id_postgres) {
        return true;
      } else if (
        conversation?.atendida &&
        conversation?.atendente?.id_postgres
      ) {
        return false;
      }
    }

    if (messageSendingBlocked) {
      return true;
    }
    return false;
  }, [conversation, queuesChatLoggedValues, messageSendingBlocked]);

  return conversation ? (
    <div
      id="chat-drop-zone"
      onPaste={handleOnInputPaste}
      onDrop={onDropHandle}
      onDragOver={handleOnDragOver}
      style={{ all: 'unset', display: 'grid', height: '100%' }}
    >
      <Header>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <h3 className="display-5 headerTitle">
            {verifyContactInfoName()}
            {clientTyping && <span className="typing">está digitando...</span>}
          </h3>
        </div>

        <HeaderOptions>
          <Option title={'Baixar todos os arquivos da conversa'}>
            {isLoading ? (
              <ReactLoader width="20px" height="20px" />
            ) : (
              <Button
                disabled={isLoading}
                color="link"
                size="sm"
                style={{
                  width: '100%',
                  height: '100%',
                  padding: 0
                }}
                onClick={() => baixarTodasAsMidias()}
              >
                <MdFileDownload size={20} color="#32325d" />
              </Button>
            )}
          </Option>
          {verifyRoles(['ACTIVE_CONTACT']) && (
            <AddActiveContact
              name="Adicionar Novo Contato"
              tooltipTitle="Adicionar usuário aos contatos ativos"
              conversation={conversation}
            ></AddActiveContact>
          )}
          <ClickToCall
            title={`Retornar ligação!\nÉ necessário estar logado em um ramal para realizar a chamada!`}
            callBack={callBack}
            color="link"
            icon={<MdPhoneForwarded size={20} color="#32325d" />}
            disableClickToCall={disableClickToCall}
          />
          <ResumeConversation
            name="Resumo do atendimento"
            tooltipTitle="Resumo"
            conversation={conversation}
          />
          <TimelineConversation
            name="Timeline do atendimento"
            tooltipTitle="Timeline"
            timeline={conversation.timeline}
          />
          <ContactDetails contactId={getIdClientFromChat(conversation)} />
          <ModalLeadOpportunity contactId={getIdClientFromChat(conversation)} />
          <HistoryConversation
            name="Histórico de atendimentos"
            tooltipTitle="Histórico"
            id={customerId}
            telefone={phoneCustomer}
          />
          <TransferConversation
            name="Transferir atendimento"
            tooltipTitle="Transferir"
            id={conversation._id ?? conversation.id}
            conversation={conversation}
            attendantCurrent={conversation.atendente.name}
            //*
            isCurrentAgentsLogged={loggedAttendants}
          />
          <CloseConversation
            id={conversation?._id ? conversation?._id : conversation?.id}
            isDisabled={false}
            name="Encerrar atendimento"
            tooltipTitle="Encerrar"
            conversation={conversation}
            reason={conversation.motivo}
            subReason={conversation.submotivo}
            protolEndOfConversation={shouldCreateProtocol}
            idProtocol={conversation.idProtocolo}
            recordType={conversation.recordType}
            skipProtocolCreation={!shouldCreateProtocol}
          />
        </HeaderOptions>
      </Header>
      <Hr className="mb-1" />
      <Dialog inReplyToMessageId={inReplyToMessageId} onScroll={handleScroll}>
        {!isAtBottom && conversation && conversation.mensagens?.length > 4 && (
          <NewMessagesIndicator
            unreadCount={
              unreadMessagesByConversation[conversation._id ?? conversation.id]
            }
            onClick={handleIndicatorClick}
          />
        )}

        {/* //alteração feita para o sussurro */}
        {conversation.mensagens.map((el, index) => {
          const normalizedType = (
            el.response_type ||
            el.type ||
            ''
          ).toLowerCase();
          let source = el.source || el.url || '';
          source = source.replace('download=false', 'download=true');

          if (normalizedType === 'text' && (!el?.texto || el?.texto === '')) {
            return null;
          }

          if (
            el.cliente_ou_atendente === 'atendente' &&
            normalizedType === 'text' &&
            el.texto.trim() === ''
          ) {
            return null;
          }

          const isAttendantOrAdmin =
            el.cliente_ou_atendente === 'atendente' ||
            el.cliente_ou_atendente === 'admin';

          if (isAttendantOrAdmin) {
            if (el.cliente_ou_atendente === 'atendente') {
              return (
                <UserBalloon
                  context={
                    el.context
                      ? conversation.mensagens.find(
                          (mensagen) =>
                            mensagen.id_mensagem_whatsapp ===
                            el.context.in_reply_to
                        )
                      : null
                  }
                  key={`conversationinattendance+${conversation._id}+${index}`}
                  name={el.escrita_por}
                  type={normalizedType}
                  message={el.texto}
                  title={el.title}
                  time={el.hora_da_mensagem}
                  options={el.options}
                  source={source}
                  status={el.status}
                  description={el.description}
                  className="userBalloon"
                  whatsappMessageId={el.id_mensagem_whatsapp}
                  scrollToMessage={scrollToMessage}
                  highlighted={highlightedMessageId === el.id_mensagem_whatsapp}
                />
              );
            } else {
              return (
                <SpyBallon
                  key={`conversationinattendance+${conversation._id}+${index}`}
                  name={el.escrita_por}
                  type={normalizedType}
                  message={el.texto}
                  title={el.title}
                  status={el.status}
                  time={el.hora_da_mensagem}
                  options={el.options}
                  source={source}
                  description={el.description}
                />
              );
            }
          } else {
            return (
              <ClientBalloon
                context={
                  el.context
                    ? conversation.mensagens.find(
                        (mensagen) =>
                          mensagen.id_mensagem_whatsapp ===
                          el.context.in_reply_to
                      )
                    : null
                }
                todasMensagens={conversation.mensagens}
                teste={el}
                key={`conversationinattendance+${conversation._id}+${index}`}
                name={el.escrita_por}
                contact={el.contact}
                type={normalizedType}
                message={el.texto}
                title={el.title}
                time={el.hora_da_mensagem}
                options={el.options}
                description={el.description}
                source={source}
                whatsappMessageId={el.id_mensagem_whatsapp}
                setInReplyToMessageId={setInReplyToMessageIdHandler}
                scrollToMessage={scrollToMessage}
                highlighted={highlightedMessageId === el.id_mensagem_whatsapp}
                isClientNotActive={
                  !clientActiveSession && isWhatsappOrFacebookChannel
                }
              />
            );
          }
        })}

        <div ref={messagesEndRef} />
      </Dialog>

      {shouldBlock ? (
        <PauseBlockerCustomerInactive />
      ) : !clientActiveSession && isWhatsappOrFacebookChannel ? (
        <MessageSendingBlockerCustomerInactive
          onClick={handlerShowModalConversation}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            flexDirection: 'column'
          }}
        >
          <Select
            styles={custom_select_40vw}
            menuPlacement="auto"
            isClearable={false}
            placeholder="Buscar mensagens predefinidas..."
            isSearchable={true}
            name="color"
            menuPosition="top"
            options={filterPredefinedMessageOptions}
            filterOption={(option, inputValue) =>
              customFilter(option, inputValue)
            }
            onChange={(e) => {
              setMessage(e.value || '');
              selectPredefinedMessage(e);
            }}
            getOptionLabel={(option) => formatPredefinedMessageOption(option)}
          />
          <PredefinedMessageModal
            predefinedMessages={unconvertedPredefinedMessageOptions}
            open={isPredefinedMessageModalOpen}
            setIsOpen={setIsPredefinedMessageModalOpen}
            messageFieldsToRender={['message']}
            setPredefinedMessage={(transformedMessage) => {
              setMessage(transformedMessage.value || '');
              selectPredefinedMessage(transformedMessage);
            }}
            transformResult={
              /**
               * @param {TemplateMessage} a
               * @returns {ConvertedTemplateMessage}
               */
              (a) => ({
                equipes: a.channel,
                label: a.title,
                preDefinedMessageMidiaUrl: a.preDefinedMessageMidiaUrl,
                value: a.message,
                whenToSend: a.whenToSend
              })
            }
          />
          <div
            onClick={async () => {
              await verifyClientStatus();

              return;
            }}
          >
            {inReplyToMessageId && context && (
              <ReplyContainerOnTopOfInput>
                <ReplyMessage
                  context={context}
                  handleScrollToMessage={() =>
                    scrollToMessage(context.id_mensagem_whatsapp)
                  }
                  color={systemConfiguration.primary_color}
                  backgroundColor={'#d1d1d1'}
                />
                <button
                  onClick={() => setInReplyToMessageId(null)}
                  className="closeReply"
                >
                  <MdClose
                    size={24}
                    color={systemConfiguration.primary_color}
                  />
                </button>
              </ReplyContainerOnTopOfInput>
            )}
            <Bottom clientActiveSession={clientActiveSession}>
              <LeftArea>
                <Button
                  className="shadow-none"
                  color="link"
                  size="sm"
                  title="Emoji"
                  onClick={() => {
                    setShowEmojis(!showEmojis);
                  }}
                >
                  <MdOutlineEmojiEmotions size={22} />
                </Button>
                {showEmojis && (
                  <div ref={wrapperRef} className="pickerZone">
                    <Picker
                      disableSearchBar={true}
                      onEmojiClick={onEmojiClick}
                      id="emojiZone"
                    />
                  </div>
                )}
                <Button
                  className="shadow-none"
                  color="link"
                  size="sm"
                  title="Enviar arquivo"
                  onClick={() => changeStatus(true)}
                >
                  <RiAttachment2 size={22} />
                </Button>
              </LeftArea>

              <InputContainer>
                <TextareaAutosize
                  id="text-area"
                  autoFocus={true}
                  style={{
                    width: '100%',
                    marginLeft: '1rem',
                    background: '#fff',
                    border: '1px solid #cbd5e1'
                  }}
                  placeholder="Escreva a mensagem..."
                  onChange={handleMessageChange}
                  onKeyPress={handlePressEnter}
                  onClick={() => setShowEmojis(false)}
                  value={messages[getIdClientFromChat(conversation)] || ''}
                  ref={messageArea}
                  disabled={!clientActiveSession || isSending}
                />
                {isSending && (
                  <div className="inputLoader">
                    <ReactLoader height={35} />
                  </div>
                )}
              </InputContainer>
              <RightArea>
                <WhisperModal
                  id={conversation._id ?? conversation.id}
                  name="Comentário privado"
                  tooltipTitle="Comentário privado"
                  isChat={true}
                />
                {/* <Button
                  className="shadow-none"
                  color="link"
                  size="sm"
                  title="Mensagens pré-definidas"
                  onClick={() => {
                    setIsPredefinedMessageModalOpen(true);
                  }}
                >
                  <PiChatCircleTextBold size={20} />
                </Button> */}
                <div
                  style={{
                    width: '1px',
                    height: '40px',
                    backgroundColor: '#cbd5e1',
                    margin: '0 .5rem'
                  }}
                />
                {window.isSecureContext === true && (
                  <AudioSender
                    id={conversation._id ?? conversation.id}
                    setRecording={setRecording}
                    conversation={conversation}
                    inReplyToMessageId={inReplyToMessageId}
                    setInReplyToMessageId={setInReplyToMessageIdHandler}
                  />
                )}

                {recording === false && (
                  <Button
                    className="shadow-none"
                    color="link"
                    size="sm"
                    onClick={onSubmitMiddleware}
                    title="Enviar"
                    disabled={
                      !message?.trim() ||
                      (isSending && !selectMessagePredefined)
                    }
                  >
                    <IoSend size={20} />
                  </Button>
                )}
              </RightArea>
            </Bottom>
          </div>
        </div>
      )}

      <UploadFile
        id={conversation._id ?? conversation.id}
        isModalOpen={isOpen}
        onModalToggle={changeStatus}
        unmountOnClose={true}
        disabledSubmit={conversation.canal === 'instagram'}
        defaultFiles={filesLoadedOnPaste}
        conversation={conversation}
        inReplyToMessageId={inReplyToMessageId}
        setInReplyToMessageId={setInReplyToMessageIdHandler}
      />
      <TemplatesModal
        id={conversation._id ?? conversation.id}
        show={modalConversationVisbility}
        onModalToggle={setModalConversationVisbility}
        showCloseButton={false}
        conversation={conversation}
        contactId={contactId}
        clientId={getIdClientFromChat(conversation)}
        queue={conversation.fila}
      />
    </div>
  ) : (
    <EmptyAttendance>Nenhuma conversa em atendimento...</EmptyAttendance>
  );
};

export default AttendanceContent;
